<template>
  <div class="widget-status">
    <div class="status-dot" :class="status"></div>
    <div class="status-content" v-if="status == 'pending'">Pending</div>
    <div class="status-content" v-if="status == 'ongoing'">Ongoing</div>
    <div class="status-content" v-if="status == 'completed'">Completed</div>
  </div>
</template>

<script>
export default {
  name: "widget-status",
  props: {
    status: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.widget-status {
  display: flex;
  align-items: center;
  .status-dot {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    margin-right: 10px;
    &.pending {
      background: #ffb201;
    }
    &.ongoing {
      background: #a27fff;
    }
    &.completed {
      background: #17b355;
    }
  }
  .status-content {
    color: #000;
  }
}
</style>
